import {
  ClearOutlined,
  DeleteOutlined,
  EditOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  Form,
  Row,
  Col,
  Divider,
  Table,
  Input,
  Space,
  Button,
  notification,
  Popconfirm,
  Tooltip,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import { AdminService } from "src/resources/AdminService";

const Positions = () => {
  const [form] = Form.useForm();
  const [initialRender, setInitialRender] = useState(true);
  const [positions, setPositions] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [newName, setNewName] = useState("");

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      AdminService.getPositions().then((data) => {
        setPositions(data.data);
      });
    }
  }, [initialRender]);

  const onFinish = (values) => {
    console.log(values);
    AdminService.newPosition(values).then((data) => {
      setInitialRender(true);
      onReset();
    });
  };
  const onReset = () => {
    form.resetFields();
  };

  const deletePosition = (id) => {
    console.log(id);
    AdminService.deletePosition(id).then((data) => {
      notification.success({
        message: "Success!",
        description: "Position deleted!",
      });
      setInitialRender(true);
    });
  };
  const editPosition = (item) => {
    console.log(item);
    setEditItem(item);
    setNewName(item.name);
    setEditModal(true);
  };
  const goEdit = () => {
    setEditModal(false);
    console.log(newName);
    AdminService.UpdatePosition({ id: editItem.id, name: newName }).then(
      (data) => {
        notification.success({
          message: "Success!",
          description: "Position updated!",
        });
        setInitialRender(true);
      }
    );
  };

  const columns = [
    {
      title: "Position Name",
      dataIndex: "name",
    },
    {
      title: "Actions",
      render: (item) => (
        <Space>
          <Tooltip title="Delete Position" placement="left" key={item.id}>
            <Popconfirm
              title="Are you sure ?"
              onConfirm={() => deletePosition(item.id)}
              okText="Yes! Delete."
              cancelText="Cancel"
            >
              <Button type="primary" danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </Tooltip>
          <Tooltip title="Update Position" placement="left" key={item.id}>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => editPosition(item)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
  return (
    <div className="max-w-6xl p-2 mx-auto">
      {editItem && (
        <Modal
          visible={editModal}
          onCancel={() => setEditModal(false)}
          onOk={() => goEdit()}
        >
          <div>
            <p>Type new name</p>
            <Input
              placeholder="Type faculty name"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
          </div>
        </Modal>
      )}
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
          <Divider orientation="left">Positions</Divider>
          <Table
            rowKey="id"
            bordered
            size="small"
            dataSource={positions}
            loading={positions === null}
            columns={columns}
            className="lg:mr-12 border border-gray-200"
            pagination={false}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
          <Divider orientation="left">Add new Position</Divider>
          <Form
            form={form}
            onFinish={onFinish}
            onReset={onReset}
            layout="vertical"
          >
            <Form.Item
              label="Position Name"
              name="name"
              rules={[
                { required: true, message: "Position name is required!" },
              ]}
            >
              <Input placeholder="Please type position name" />
            </Form.Item>

            <Form.Item className="mt-6">
              <Space>
                <Button
                  type="default"
                  htmlType="reset"
                  icon={<ClearOutlined />}
                >
                  Clear
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                >
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default Positions;
